import {
  MotifLabel,
  MotifFormField,
  MotifInput,
  MotifCheckbox,
  MotifSelect,
  MotifOption,
  MotifButton,
  MotifAccordion,
  MotifAccordionContent,
  MotifAccordionTrigger,
  MotifErrorMessage,
  MotifProgressLoader,
} from "@ey-xd/motif-react";
import { useMemo, useState } from "react";
import { EditSubAccount } from "./EditSubAccount";
import { useGetSubAccountDataByIdApiDataQuery } from "@/services/configuration/configuration";
import DeleteAccountSubAccount from "./DeleteAccountSubAccount";
import NotificationGrid from "@/components/Notification/NotificationGrid";
import { subAcountRecordType } from "./type";
import { useGetEffectiveSchemesQuery } from "../../Voting/votingReducer";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { havingDeletePermission, havingEditPermission } from "@/utility/common";
import {
  DELETE_IMG_VARIANT,
  EDIT_IMG_VARIANT,
  getCommonDeleteImg,
  getCommonEditImg,
} from "@/components/Images/CommonImages";
import CommonTooltipWrapper from "@/components/Tooltip/CommonTooltipWrapper";
import { useSelector } from "react-redux";

export default function SubAccountTile({
  subAccountList,
  setStatusMsg,
  refetchSubAccounts,
  setIsDiscardVisible,
  editSubAccount,
  setEditSubAccount,
  SubAccount,
  subAccountsFetching,
  loadingSubAccountError,
  setSubAccountErrorMessages: setDeleteErrorMessage,
  subAccountErrorMessages: deleteErrorMessage,
  setShowDeleteSuccessErrorMessage,
  showDeleteSuccessErrorMessage,
}: any) {
  const accountSetupDetails = useSelector((state: any) => state.accountSetup);

  const [editId, setEditId] = useState(accountSetupDetails?.subAccountId || "");
  const { t } = useTranslation();
  const [showDeleteSubAccount, setShowDeleteSubAccount] = useState(false);
  const [deleteId, setDeleteId] = useState("");
  const { data: getSubAccountById, refetch: editRefetch } =
    useGetSubAccountDataByIdApiDataQuery(editId.toString(), { skip: !editId });
  const [subAccountFields, setSubAccountFields] = useState<any>({
    name: "",
    desc: "",
    nameFr: "",
    descFr: "",
    schemeVersionId: "",
    includeIntaxReport: false,
    includeInPaymentRegister: false,
  });
  function handleSubAccountFocus() {
    if (accountSetupDetails?.subAccountId) {
      let doc1 = document.getElementById(accountSetupDetails?.subAccountId);
      doc1?.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  }
  //Set up the form value
  const [deleteEntityName, setDeleteEntityName] = useState("");
  const handleChange = (name: any, value: any) => {
    setSubAccountFields({ ...subAccountFields, [name]: value });
  };
  const { caseId } = useParams<{ caseId: string }>();
  const { data: dataSchemes, isLoading: isLoadingSchemes } =
    useGetEffectiveSchemesQuery({ caseId }, { skip: !caseId });
  const SCHEME_OPTIONS: any[] = useMemo(() => {
    if (dataSchemes && !isLoadingSchemes) {
      return dataSchemes.map((item: subAcountRecordType) => {
        return {
          label: item?.name || "",
          value: item?.schemeVersionId || "",
        };
      });
    }

    return [];
  }, [isLoadingSchemes, dataSchemes]);
  const defaultOption = { label: "Select Type", value: "" };
  const SchemeOptions = [defaultOption, ...SCHEME_OPTIONS];
  if (subAccountsFetching) {
    return <MotifProgressLoader></MotifProgressLoader>;
  }
  if (loadingSubAccountError) {
    return (
      <>
        <br />
        <div
          style={{ width: "100%" }}
          className="motif-row justify-content-center align-items-center"
        >
          <MotifErrorMessage>
            {t("global.globalNotifications.wentWrong")}
          </MotifErrorMessage>
        </div>
      </>
    );
  }

  return (
    <>
      <div
        className={`status-body ${
          subAccountList?.length > 0 ? `subaccountBody` : ``
        }`}
      >
        {deleteErrorMessage.message &&
          deleteErrorMessage.type === "success" && (
            <NotificationGrid
              show={true}
              message={deleteErrorMessage.message}
              type={deleteErrorMessage.type}
              onClose={() => {
                setDeleteErrorMessage({ message: "", type: "" });
              }}
            />
          )}
        {subAccountList && subAccountList.length > 0 ? (
          subAccountList.map((items: any, index: number) => {
            return (
              <div
                key={items.subAccountId}
                className="status-tile-container sub-accounts_accordian"
                id={`${items.subAccountId}`}
                onClick={() => {
                  setEditId(
                    editId === "" || editId !== items?.subAccountId
                      ? items?.subAccountId
                      : editId
                  );
                }}
              >
                {deleteErrorMessage.message &&
                  deleteErrorMessage.type === "error" &&
                  deleteId === items?.subAccountId && (
                    <NotificationGrid
                      scrollToTop={false}
                      show={true}
                      message={deleteErrorMessage.message}
                      type={deleteErrorMessage.type}
                      onClose={() => {
                        setDeleteErrorMessage({ message: "", type: "" });
                      }}
                    />
                  )}
                <MotifAccordion
                  style={{
                    flex: "1",
                    color: "black",
                  }}
                  useChevronIcon={true}
                  alignIconRight
                  open={editId === items?.subAccountId}
                  onClose={() => function Ua() {}}
                  onOpen={function Ua() {}}
                >
                  <MotifAccordionTrigger>
                    <div>
                      <div
                        className="motif-body1-default-bold"
                        style={{ color: "black" }}
                        onClick={() => {
                          // setEditSubAccount(true);
                          // setEditId(items?.subAccountId);
                        }}
                        title={items?.subAccountName || ""}
                      >
                        {items?.subAccountName}
                      </div>
                      <div className="status-tile-actions">
                        <div
                          className="action-icons"
                          style={{
                            borderRight: "0px",
                            paddingRight: "0px",
                            display: "flex",
                            gap: "13px",
                            position: "absolute",
                            top: "20px",
                            right: "60px",
                          }}
                        >
                          {havingEditPermission(SubAccount) && (
                            <CommonTooltipWrapper
                              tooltipTitle={t("global.globalActions.edit")}
                            >
                              <MotifButton
                                className="acc-icon-btn"
                                type="button"
                                variant={EDIT_IMG_VARIANT}
                                onClick={() => {
                                  setEditSubAccount(true);
                                  setEditId(items?.subAccountId);
                                  setShowDeleteSuccessErrorMessage({
                                    message: "",
                                    type: "",
                                    variant: "",
                                    index: "",
                                    show: false,
                                  });
                                }}
                              >
                                {getCommonEditImg()}{" "}
                              </MotifButton>
                            </CommonTooltipWrapper>
                          )}
                          {havingDeletePermission(SubAccount) && (
                            <CommonTooltipWrapper
                              tooltipTitle={t("global.globalActions.delete")}
                            >
                              <MotifButton
                                className="acc-icon-btn"
                                type="button"
                                variant={DELETE_IMG_VARIANT}
                                onClick={() => {
                                  setShowDeleteSubAccount(true);
                                  setDeleteId(items?.subAccountId);
                                  setDeleteEntityName(items?.subAccountName);
                                  setDeleteErrorMessage({
                                    message: "",
                                    type: "",
                                  });
                                  setShowDeleteSuccessErrorMessage({
                                    message: "",
                                    type: "",
                                    variant: "",
                                    index: index - 1,
                                    show: false,
                                  });
                                }}
                              >
                                {getCommonDeleteImg()}{" "}
                              </MotifButton>
                            </CommonTooltipWrapper>
                          )}
                        </div>
                      </div>
                    </div>
                  </MotifAccordionTrigger>
                  <MotifAccordionContent>
                    <div className="status-tile-body mar-t-0 mar-b-0">
                      <div className="motif-row mar-b-10">
                        <div className="motif-col-sm-2">
                          <MotifLabel
                            className="mar-b-10"
                            style={{ display: "block" }}
                          >
                            {t(
                              "pages.distributions.account.subAccountLabels.name"
                            )}
                          </MotifLabel>
                          <MotifFormField>
                            <MotifInput
                              /**@ts-ignore **/
                              placeholder="Name"
                              disabled
                              onBlur={function Ua() {}}
                              onFocus={function Ua() {}}
                              hideClearButton={true}
                              value={
                                subAccountFields?.name || items?.subAccountName
                              }
                              onChange={(e: any) =>
                                handleChange("name", e.target.value)
                              }
                            />
                          </MotifFormField>
                        </div>
                        <div className="motif-col-sm-2 mar-b-10">
                          <MotifLabel
                            className="mar-b-10"
                            style={{ display: "block" }}
                          >
                            {t(
                              "pages.distributions.account.subAccountLabels.nameFrench"
                            )}
                          </MotifLabel>
                          <MotifFormField>
                            <MotifInput
                              /**@ts-ignore **/
                              placeholder="Name (French)"
                              disabled
                              onBlur={function Ua() {}}
                              onFocus={function Ua() {}}
                              hideClearButton={true}
                              value={
                                subAccountFields?.nameFr ||
                                items?.nameFrench ||
                                ""
                              }
                              onChange={(e: any) =>
                                handleChange("nameFr", e.target.value)
                              }
                            />
                          </MotifFormField>
                        </div>
                      </div>
                      <MotifLabel className="mar-b-10">
                        {t(
                          "pages.distributions.account.subAccountLabels.description"
                        )}
                      </MotifLabel>
                      <MotifFormField className="mar-b-10">
                        <MotifInput
                          /**@ts-ignore **/
                          placeholder="Description"
                          disabled
                          onBlur={function Ua() {}}
                          onFocus={function Ua() {}}
                          hideClearButton={true}
                          value={
                            subAccountFields?.desc ||
                            items?.subAccountDescription ||
                            ""
                          }
                          onChange={(e: any) =>
                            handleChange("desc", e.target.value)
                          }
                        />
                      </MotifFormField>
                      <MotifLabel className="mar-b-10">
                        {t(
                          "pages.distributions.account.subAccountLabels.descriptionFrench"
                        )}
                      </MotifLabel>
                      <MotifFormField className="mar-b-10">
                        <MotifInput
                          /**@ts-ignore **/
                          placeholder="Description (French)"
                          disabled
                          value={
                            subAccountFields?.descFr ||
                            items?.descriptionFrench ||
                            ""
                          }
                          onChange={(e: any) =>
                            handleChange("descFr", e.target.value)
                          }
                        />
                      </MotifFormField>
                      <div className="form-field">
                        <MotifLabel className="mar-b-10">
                          {t(
                            "pages.distributions.account.subAccountLabels.payemntOrderScheme"
                          )}
                        </MotifLabel>
                        <MotifSelect
                          placeholder=""
                          value={
                            subAccountFields?.schemeVersionId ||
                            items?.schemeVersionId
                          }
                          disabled
                        >
                          {SchemeOptions.map((option) => (
                            <MotifOption
                              key={option.value}
                              value={option.value}
                            >
                              {option.label}
                            </MotifOption>
                          ))}
                        </MotifSelect>
                      </div>
                      {/* <div style={{ marginTop: "10px" }}>
                        <MotifCheckbox
                          style={{ marginTop: "10px" }}
                          checked={
                            subAccountFields?.includeIntaxReport ||
                            items?.isInTaxReport
                          }
                          onChange={(e: any) =>
                            handleChange("includeIntaxReport", e.target.value)
                          }
                        >
                          {t(
                            "pages.distributions.account.subAccountLabels.includeTaxReport"
                          )}
                        </MotifCheckbox>
                      </div> */}
                      <MotifCheckbox
                        checked={
                          subAccountFields?.includeInPaymentRegister ||
                          items?.isInPaymentRegister
                        }
                        onChange={(e: any) =>
                          handleChange(
                            "includeInPaymentRegister",
                            e.target.value
                          )
                        }
                      >
                        {t(
                          "pages.distributions.account.subAccountLabels.includePaymentRegister"
                        )}
                      </MotifCheckbox>
                    </div>
                  </MotifAccordionContent>
                </MotifAccordion>
                {showDeleteSuccessErrorMessage.show &&
                  showDeleteSuccessErrorMessage.index === index &&
                  showDeleteSuccessErrorMessage.index >= 0 &&
                  showDeleteSuccessErrorMessage.variant === "subAccount" && (
                    <>
                      <br></br>{" "}
                      <NotificationGrid
                        show={showDeleteSuccessErrorMessage.show}
                        message={showDeleteSuccessErrorMessage.message}
                        type={showDeleteSuccessErrorMessage.type}
                        scrollToTop={false}
                        onClose={() =>
                          setShowDeleteSuccessErrorMessage({
                            message: "",
                            type: "",
                            variant: "",
                            index: "",
                            show: false,
                          })
                        }
                      />
                    </>
                  )}
              </div>
            );
          })
        ) : (
          <>
            <div className="motif-row justify-content-center align-items-center">
              {t("global.globalNotifications.noRecords")}
            </div>
          </>
        )}
      </div>
      <DeleteAccountSubAccount
        show={showDeleteSubAccount}
        setShow={setShowDeleteSubAccount}
        id={deleteId}
        isAccount={false}
        setDeleteErrorMessage={setDeleteErrorMessage}
        refetch={refetchSubAccounts}
        deleteEntityName={deleteEntityName}
        setStatusMsg={setStatusMsg}
        setShowDeleteSuccessErrorMessage={setShowDeleteSuccessErrorMessage}
        showDeleteSuccessErrorMessage={showDeleteSuccessErrorMessage}
      />
      {editSubAccount && (
        <EditSubAccount
          setEditSubAccount={setEditSubAccount}
          editSubAccount={editSubAccount}
          getSubAccountById={getSubAccountById}
          editRefetch={editRefetch}
          refetchSubAccounts={refetchSubAccounts}
          editId={editId}
          setStatusMsg={setStatusMsg}
          setIsDiscardVisible={setIsDiscardVisible}
        />
      )}
      {handleSubAccountFocus()}
    </>
  );
}
